














































































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
import moment from 'moment';
// import { DEFAULT_DATE_FORMAT } from '@/common/config'
import { GANG_STOP_CREATE, GANG_STOP_EDIT, GANG_STOP_DETAIL } from '../router-names';
// import { debounce } from 'lodash'
import * as _ from 'lodash';

import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
// axios请求
import {
  querySentryList,
  editPasswordSentry,
  disableOrEnableSentry,
  deleteSentry
} from '../../../api/parking-lot-management/index';
import Utils from '@/utils/common';
import { dictuserModeMap, dictChannelTypeMap } from '../../../types/parking-lot-management/dictionaries';
// form表单项定义
export interface IForm {
  password: string;
  passwordTwo: string;
}
@Component({
  name: 'GangStopPerson',
  components: {
    ParkingLotSearch
  }
})

// @Component
export default class GangStopPerson extends Mixins(TableMixin, TableWidthMixin) {
  queryChannelListDebounce: any = function() {}; // 列表防抖请求
  username = '';
  enabled = '02';
  parkId = ''; // 车场ID,多个车场ID逗号分隔
  status = '00'; //使用状态:01生效，00无效，02全部
  tableLoading = false; //表单数据loading
  id = '';
  dataForm = {
    password: '',
    passwordTwo: ''
  };
  parkIds = [];

  // 使用状态切换
  dictuserModeOptions: IOption[] = Utils.toLabelVal(dictuserModeMap);
  // value: string = ''
  // 表单
  form: any = null;
  tableData: any[] = []; // 表数据
  // visible: boolean = false
  isvisible: boolean = false;
  // 车场名称/ 区域名称下拉框
  // parkAreaList = []

  // model点击取消关闭model
  closeModelSub() {
    this.isvisible = false;
    this.form.resetFields();
  }

  showModalSmall(id: string) {
    this.id = id;
    this.isvisible = true;
  }

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 70,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '姓名',
        dataIndex: 'realName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '账号',
        dataIndex: 'username',
        width: 160,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      // {
      //   title: '性别',
      //   dataIndex: 'sexDesc',
      //   width: 160,
      //   customRender: (text: any) => text || '--',
      // },
      {
        title: '手机号',
        dataIndex: 'mobile',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '状态',
        dataIndex: 'enabled',
        width: 160,
        // customRender: (text: any) => text || '--',
        scopedSlots: { customRender: 'enabled' }
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 200,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }

  // 生命周期初始化表单
  created() {
    this.init();
    this.fetchTableData();
  }

  // 初始化form表单
  init() {
    // if (this.dataForm) {
    //   this.form = this.$form.createForm(this, {
    //     mapPropsToFields: () => {
    //       const { payUrl, noPlateEnterUrl, noPlateExitUrl } = this.dataForm
    //       return {
    //         payUrl: this.$form.createFormField({
    //           value: payUrl,
    //         }),
    //         noPlateEnterUrl: this.$form.createFormField({
    //           value: noPlateEnterUrl,
    //         }),
    //         noPlateExitUrl: this.$form.createFormField({
    //           value: noPlateExitUrl,
    //         }),
    //       }
    //     },
    //   })
    // } else {
    this.form = this.$form.createForm(this);
    // }
  }
  //

  /**
   * 请求数据列表
   */
  async fetchTableData(isRefresh?: boolean) {
    if (this.tableLoading) return;
    this.tableLoading = true;
    if (isRefresh) this.current = 1;
    try {
      const { status, code, msg, data } = await querySentryList({
        parkId: this.parkIds.join(','),
        username: this.username,
        enabled: this.enabled,
        status: this.status,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      this.tableData = datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
    } catch (e) {
      // console.log('queryParkList error')
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  // 禁用启用事件
  async isforbiddenChange(row: any) {
    const { id } = row;
    this.id = id;
    try {
      const { status, msg, code, data } = await disableOrEnableSentry({
        id,
        status: row.enabled === '01' ? '00' : '01'
      });
      this.$message.success('操作成功');
      this.fetchTableData();
    } catch (e) {
      this.$message.error((e && e.msg) || '操作失败');
    }
    // 调接口
    // this.getDisableEnabled(id)
  }

  // 模态框提交事件
  async handleSubmit(e: { preventDefault: () => void }) {
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        if (values.password !== values.passwordTwo) {
          return this.$message.warning('两次密码不一致');
        }
        this.editPassword(values);
        this.closeModelSub();
      }
    });
  }
  // 修改密码
  async editPassword(values: any) {
    try {
      const { status, msg, code, data } = await editPasswordSentry({ id: this.id, ...values });
      this.$message.success('设置成功');
      this.form.resetFields();
    } catch (e) {
      this.$message.error((e && e.msg) || '设置失败');
    }
  }
  //搜索
  searchTableData() {
    this.fetchTableData(true);
  }
  // 清空搜索条件
  clear({ defaultParkIdList = [] }) {
    this.parkIds = defaultParkIdList;
    this.username = '';
    this.enabled = '02';
    this.fetchTableData(true);
  }
  // 跳转到编辑
  toUpdate(id: string) {
    this.$router.push({
      name: GANG_STOP_EDIT,
      params: {
        id
      }
    });
  }

  // 新增跳转
  toCreate() {
    this.$router.push({
      name: GANG_STOP_CREATE
    });
  }
  // 点击详情
  toDetail(id: string) {
    this.$router.push({
      name: GANG_STOP_DETAIL,
      params: {
        id
      }
    });
  }
  /**
   * 删除项
   */
  async toDelete(row: any) {
    try {
      //
      const { status, data, msg, code } = await deleteSentry({ id: row.id });
      this.$message.success('删除成功');
      this.fetchTableData();
    } catch (e) {
      this.$message.error((e && e.msg) || '删除失败');
    }
  }
  /**
   * 导出事件
   */
  // exportHandle
  // async exportHandle() {
  //   try {
  //     const { status, code, msg, data } = await exportChannelList(this.filterParam)
  //     // 成功
  //   } catch (error) {
  //     console.log('queryParkList error')
  //   }
  // }
}
